import { useNostoApi } from './useNostoApi';

/**
 * Sends category page viewed action to the Nosto.
 * @param category - The category to be viewed.
 */
export function useNostoCategory(category: string) {
  useNostoApi(async (api) => {
    // eslint-disable-next-line prettier/prettier
    return api.defaultSession()
              .viewCategory(category)
              .setPlacements(api.placements.getPlacements())
              .load();
  }, 'CATEGORY');
}
